import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';

import { Typography } from "antd";

import { getContacts } from "store/app/actions";
import { getCompaniesInfo } from 'store/app/actions';

import EmailListings from "components/Contact/EmailListing";
import ContactInfo from 'components/Contact/Info';

import './index.scss';

const { Title } = Typography;

export interface ContactUsPageProps {
  getContacts(): any,
  isFetchingContacts: boolean,
  getCompaniesInfo(): any,
  isFetchingCompanyInfo: boolean,
};

const ContactUsPage = (props: ContactUsPageProps) => {

  return (
    <div className="contact-us-page">
      <div className="header-title">
        <Title level={4} className="ml-3">Contact Us</Title>
      </div>
      <div className="search-section">
        <ContactInfo
          getCompaniesInfo={props.getCompaniesInfo}
          isFetchingCompanyInfo={props.isFetchingCompanyInfo}
        />
      </div>
      <div className="content">
        <EmailListings
          getContacts={props.getContacts}
          isFetchingContacts={props.isFetchingContacts}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingContacts: store.rootReducer.app.isFetchingContacts,
  isFetchingCompanyInfo: store.rootReducer.app.isFetchingCompanyInfo,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getContacts,
    getCompaniesInfo,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsPage);